import { useAccess } from '../hooks/useAccess';
import AccessDenied  from './AccessDenied';

// Wrap any route/component with this guard
// <AccessGuard module="quizzes" label="AI Quizzes">
//   <TeacherQuiz />
// </AccessGuard>
const AccessGuard = ({ module, label, children }) => {
  const { allowed, loading } = useAccess(module);
  if (loading) return null; // brief flash prevention
  if (!allowed) return <AccessDenied module={label || module} />;
  return children;
};

export default AccessGuard;